/**
 * Add linkedStudentIds array to parent user document
 * This script adds the studentIds that a parent is linked to into their user document
 * for Firestore security rule validation
 */
import { doc, getDoc, setDoc, collection, query, where, getDocs } from 'firebase/firestore';
import { db, auth } from '../firebase.js';

async function addLinkedStudentIds() {
  try {
    const user = auth.currentUser;
    if (!user) {
      console.error('❌ Not logged in');
      return;
    }

    console.log('👤 User ID:', user.uid);

    // Get all active parent-child links for this parent
    const linksQuery = query(
      collection(db, 'parentChildLinks'),
      where('parentId', '==', user.uid),
      where('status', '==', 'active')
    );

    const linksSnapshot = await getDocs(linksQuery);
    const linkedStudentIds = [];

    console.log(`📎 Found ${linksSnapshot.size} active parent-child links`);

    linksSnapshot.forEach(doc => {
      const data = doc.data();
      if (data.studentId) {
        linkedStudentIds.push(data.studentId);
        console.log(`  - Student: ${data.studentId} (${data.studentName || 'Unknown'})`);
      }
    });

    if (linkedStudentIds.length === 0) {
      console.warn('⚠️ No linked students found. Are you linked to any children?');
      return;
    }

    // Update user document with linkedStudentIds array
    const userRef = doc(db, 'users', user.uid);
    const userDoc = await getDoc(userRef);
    const userData = userDoc.data();

    console.log('📄 Current user data:', userData);
    console.log('➕ Adding linkedStudentIds:', linkedStudentIds);

    await setDoc(userRef, {
      linkedStudentIds: linkedStudentIds,
      parent: true // Ensure parent flag is also set
    }, { merge: true });

    console.log('✅ Added linkedStudentIds to user document!');
    console.log('🔄 Refresh the page to test parent access.');

    return linkedStudentIds;
  } catch (error) {
    console.error('❌ Error:', error);
    throw error;
  }
}

export { addLinkedStudentIds };